export const HOME_PAGE_TITLE = 'What are you here to do today?'
